import { render } from "./SavingsPage.vue?vue&type=template&id=be4f773a"
import script from "./SavingsPage.vue?vue&type=script&lang=js"
export * from "./SavingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__